import React, { Component } from 'react';

export default class Contato extends Component {
    render(){
        return (
            <div className="Contato">
                <div className="container-big flex horizontal">
                    <div className="flex-1">
                        <h3>Contato</h3>
                        <br />
                        <div className="flex vertical">
                            <span>(11) 4372-7073</span>
                            <span>Segunda a Sexta das 9h às 17h</span>
                            <span>contato@distribuidoramhtech.com.br</span>
                            <br />
                            <span>Central de Atendimento</span>
                            <span>Trocas e Devoluções</span>
                            <span>Política de Privacidade</span>
                        </div>
                    </div>
                    <div className="flex-1">
                        <h3>Formas de Pagamento</h3>
                        <br />
                        <div className="flex vertical">
                            <span>Depósito</span>
                            <span>Transferência</span>
                            <span>Boleto</span>
                            <span>TED e DOC</span>
                            <div><br /></div>
                            <img alt="formas de pag" src={`${process.env.PUBLIC_URL}/media/image/formas_de_pagamento.png`} width="150px" />
                        </div>
                    </div>
                    <div className="flex-1">
                        <h3>Institucional</h3>
                        <br />
                        <div className="flex vertical">
                            <span>Quem somos</span>
                            <span>Nossas Lojas</span>
                            <span>Trabalhe Conosco</span>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}